import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ab81d1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "class-details-title-container" }
const _hoisted_2 = { class: "title-text-small" }
const _hoisted_3 = { class: "title-text-large" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-text-small" }, "年", -1))
const _hoisted_5 = { class: "title-text-large" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-text-small" }, "組", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.schoolTypeText), 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.gradeNumber), 1),
    _hoisted_4,
    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.name), 1),
    _hoisted_6
  ]))
}